import { render, staticRenderFns } from "./ProductInfoImage.vue?vue&type=template&id=f8b353cc&"
import script from "./ProductInfoImage.vue?vue&type=script&lang=js&"
export * from "./ProductInfoImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoImage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
